import React from 'react';
import { Container, Row, Col, Card, Button, Alert, Spinner, Badge } from 'react-bootstrap';
import { Cloud, CheckCircle, XCircle, ArrowClockwise } from 'react-bootstrap-icons';
import { useCheckS3BucketQuery } from '../services/api';
import { useAccount } from '../contexts/AccountContext';

const S3EmailStorage = () => {
  const { selectedAccount, isAllAccountsSelected } = useAccount();
  const { 
    data: bucketStatus, 
    error, 
    isLoading: loading, 
    refetch: checkBucketStatus 
  } = useCheckS3BucketQuery();

  // Bucket creation removed for safety - bucket must be created manually

  const getStatusIcon = () => {
    if (loading) return <Spinner size="sm" className="me-2" />;
    if (bucketStatus?.data?.exists) return <CheckCircle className="me-2 text-success" />;
    return <XCircle className="me-2 text-warning" />;
  };

  const getStatusColor = () => {
    if (bucketStatus?.data?.exists) return 'success';
    return 'warning';
  };

  return (
    <Card className="h-100">
      <Card.Header className="bg-primary text-white">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <Cloud className="me-2" />
            S3 Email Storage
          </h5>
          {!isAllAccountsSelected && selectedAccount?.alias && (
            <Badge bg="light" text="dark">
              {selectedAccount.alias}
            </Badge>
          )}
        </div>
      </Card.Header>
      <Card.Body>
        <Alert variant="info" className="mb-3">
          <strong>🛡️ SINGLE BUCKET ACCESS</strong><br/>
          <small>Bucket: <code>krossglobal-marketing-emails</code></small>
        </Alert>

              {error && (
                <Alert variant="danger" className="mb-4">
                  <strong>Error:</strong> {error.message || 'Failed to check bucket status. Please check your backend connection.'}
                </Alert>
              )}

              {bucketStatus?.data && (
                <Alert variant={getStatusColor()} className="mb-4">
                  <div className="d-flex align-items-center">
                    {getStatusIcon()}
                    <div>
                      <strong>
                        {bucketStatus.data.exists 
                          ? 'Email Storage Bucket Ready' 
                          : 'Email Storage Bucket Not Found'
                        }
                      </strong>
                      <div className="mt-2">
                        <small>
                          <strong>Bucket:</strong> {bucketStatus.data.bucketName}<br/>
                          <strong>Status:</strong> {bucketStatus.data.exists ? 'Available' : 'Not Found'}<br/>
                          <strong>Access:</strong> Single bucket only
                        </small>
                      </div>
                    </div>
                  </div>
                </Alert>
              )}

              <div className="d-flex gap-2">
                <Button 
                  variant="outline-secondary" 
                  size="sm"
                  onClick={checkBucketStatus} 
                  disabled={loading}
                >
                  <ArrowClockwise className="me-1" />
                  {loading ? 'Checking...' : 'Refresh'}
                </Button>
              </div>
            </Card.Body>
          </Card>
  );
};

export default S3EmailStorage;
